<template>
  <el-dialog
    :title="$t('file.ImportCustomers')"
    :visible.sync="dialogVisible"
    width="800px"
    class="importTraderDialog"
    @close="dialogCloseHandle"
  >
    <div class="common_readonly_template">
      <el-row>
        <el-col :span="24">
          <div>
            <div class="label">{{ $t('file.CustomerInfoIEX') }}</div>
            <div class="text">
              <span @click="templateDownload">
                <i class="iconfont icon-xiazai-Icon" />
                {{ $t('file.Ctdtt') }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">{{ $t('file.FileU') }}</div>
            <div class="text">
              <div>
                <el-upload
                  ref="importTraderUpload"
                  class="upload-demo"
                  :action="baseUrl"
                  :headers="uploadheaders"
                  :with-credentials="true"
                  :on-remove="beforeRemove"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :data="uploadData"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :auto-upload="false"
                >
                  <el-button type="primary" :disabled="fileList.length > 1">
                    <i class="iconfont icon-shangchuan-icon1" />
                    {{ $t('file.ctu') }}
                  </el-button>
                  <span slot="tip" class="el-upload__tip">{{ $t('file.SupFF') }}</span>
                </el-upload>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--    <div class="downloadTemplate">客户信息导入模板：<span @click="templateDownload">点击下载模板</span></div>-->
    <!--    <div class="title">文件上传</div>-->
    <!--    <el-upload-->
    <!--      ref="importTraderUpload"-->
    <!--      class="upload-demo"-->
    <!--      :action="baseUrl"-->
    <!--      :headers="uploadheaders"-->
    <!--      :with-credentials="true"-->
    <!--      :on-remove="beforeRemove"-->
    <!--      :before-upload="beforeUpload"-->
    <!--      :on-success="handleSuccess"-->
    <!--      :data="uploadData"-->
    <!--      multiple-->
    <!--      :limit="1"-->
    <!--      :file-list="fileList"-->
    <!--      :auto-upload="false"-->
    <!--    >-->
    <!--      <el-button size="small" type="primary" :disabled="fileList.length > 1">点击上传</el-button>-->
    <!--      <div slot="tip" class="el-upload__tip">支持文件格式：.xls .xlsx</div>-->
    <!--    </el-upload>-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="submitUpload">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { travellingTrader } from '../../../service';
import requestBaseUrl from '@/API/request/baseUrl';
import { getTicket } from '@/utils/utils';
import { confirmBusiness } from '@/utils/exportComplianceDialog';

export default {
  data () {
    return {
      dialogVisible: false,
      uploadheaders: {
        sysId: window._env_.VUE_APP_SYSID,
        union_session_ticket: getTicket()
      },
      baseUrl: `${requestBaseUrl}/customer/excelUpdate/3/`,
      fileList: [],
      uploadData: {}
    };
  },
  props: {
    exportTraderVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    exportTraderVisible (val) {
      if (val) {
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitUpload () {
      this.$refs.importTraderUpload.submit();
    },
    templateDownload () {
      const params = { activityCode: this.$route.query.activityCode };
      travellingTrader.exportCustomerZx(params).then(res => {
          try {
            const arrayBuffer = res.data;
            const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
            let fileName = '客户列表.xlsx';
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
              if (fileNameMatch) {
                fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
              }
            }
            const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              const url = window.URL.createObjectURL(blob);
              link.href = url;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(link);
            }
            this.$message.success(this.$t('general.ExportSuccess'));
          } catch (e) {
            this.$message.error(this.$t('general.ExportFailure'));
          }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    beforeUpload (file) {
      let fileSize = file.size / 1024 / 1024 < 10;
      if (!fileSize) {
        this.$message.error(this.$t('file.uFn10M'));
      }
      this.$store.commit('setSubPageLoading', true);
      return fileSize;
    },
    handleSuccess (response, file, fileList) {
      this.$store.commit('setSubPageLoading', false);
      confirmBusiness(this, response, { notifyError: true }).then(passed => {
        if (passed) {
          this.$emit('dialogCloseHandle');
          this.$message.success(this.$t('general.ImpSucc'));
          this.fileList = [];
        }
      });
    },
    handleError () {
      this.$store.commit('setSubPageLoading', false);
      this.$message.error(this.$t('file.Fuf'));
    },
    beforeRemove (file, fileList) {
      this.$message({
        type: 'success',
        message: this.$t('general.DeleSucc')
      });
    }
  },
  mounted () {
    if (this.$route.query.activityCode) {
      this.baseUrl = this.baseUrl + this.$route.query.activityCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.importTraderDialog {
  .common_readonly_template {
    .text > span {
      color: #508db4;
      margin-left: 8px;
      cursor: pointer;
      > i {
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .el-upload__tip {
      color: #5b646e;
      margin-left: 10px;
    }
  }
  .title {
    font-weight: bold;
    margin: 20px 0 16px;
  }
}
</style>
